import { Dispatch, FC, SetStateAction } from 'react';
import { useFormState, useMultistepApi } from 'informed';
import { FormTempValues, IYupSchema, STEPS_ICONS, STEPS_LABELS, yupSchemas } from '../../consts';
import { NavigationStepper } from '@components';
import { deepMerge } from '@common/utils';
import comCss from '../../styles.module.scss';

interface SideMenuProps {
  setYupSchema: Dispatch<SetStateAction<IYupSchema>>;
  initialValues: FormTempValues;
  isNew: boolean;
}

const SideMenu: FC<SideMenuProps> = ({ setYupSchema, initialValues, isNew }) => {
  const { setCurrent, getCurrentStep } = useMultistepApi();

  const formState = useFormState();
  const currentStep = getCurrentStep();

  const formStateValues: FormTempValues = formState.values;
  const mergedValues = isNew ? formStateValues : deepMerge(initialValues, formStateValues);
  const { details, asset, time, rules, users } = mergedValues;

  const onClick = async (step: string) => {
    // TO DO: Disable because it's make validate for whole form, need validate only one step
    // validate(); // Note can be with await for better work?
    // const { invalid } = getFormState();
    // if (invalid) {
    //   return;
    // }

    setCurrent(step);
    setYupSchema(yupSchemas[step]);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const stepsConfig = [
    {
      label: STEPS_LABELS.DETAILS,
      icon: STEPS_ICONS.DETAILS,
      isCompleted: Boolean(
        details &&
          details.address &&
          details.city_name &&
          details.country &&
          details.depot_number &&
          details.email &&
          details.latitude &&
          details.longitude &&
          details.name
      ),
      isDisabled: false,
      onClick: () => onClick('details'),
      key: 'details',
    },
    {
      label: STEPS_LABELS.RULES,
      icon: STEPS_ICONS.RULES,
      isCompleted: Boolean(rules && rules.global),
      isDisabled: !rules && currentStep !== 'rules',
      onClick: () => onClick('rules'),
      key: 'rules',
    },
    {
      label: STEPS_LABELS.TIME,
      icon: STEPS_ICONS.TIME,
      isCompleted: Boolean(time && time.start_time && time.end_time && time.weekdays),
      isDisabled: !time && currentStep !== 'time',
      onClick: () => onClick('time'),
      key: 'time',
    },
    {
      label: STEPS_LABELS.ASSET,
      icon: STEPS_ICONS.ASSET,
      isCompleted: Boolean(asset && asset.services),
      isDisabled: !asset && currentStep !== 'asset',
      onClick: () => onClick('asset'),
      key: 'asset',
    },
    {
      label: STEPS_LABELS.USERS,
      icon: STEPS_ICONS.USERS,
      isCompleted: Boolean(users && users.focal_points),
      isDisabled: !users && currentStep !== 'users',
      onClick: () => onClick('users'),
      key: 'users',
    },
    {
      label: STEPS_LABELS.REVIEW,
      icon: STEPS_ICONS.REVIEW,
      isCompleted: false,
      isDisabled: !details || !rules || !time || !asset || !users,
      onClick: () => onClick('review'),
      key: 'review',
    },
  ];

  const currentStepIdx = stepsConfig.findIndex((step) => step.key === currentStep);

  return (
    <div>
      <div className={comCss.sideTitle}>{isNew ? 'Create a new Workshop' : 'Edit Workshop'}</div>
      <NavigationStepper disableIfBeforeCurrentStep={false} config={stepsConfig} currentStep={currentStepIdx} />
    </div>
  );
};

export default SideMenu;
